import { enums } from '@optimizely/optimizely-sdk';
const voidLogger = {
    log: (level) => {
        switch (level) {
            case enums.LOG_LEVEL.DEBUG:
            case enums.LOG_LEVEL.WARNING:
            case enums.LOG_LEVEL.ERROR:
            case enums.LOG_LEVEL.INFO:
            default:
        }
    },
};
const consoleLogger = {
    log: (level, message) => {
        switch (level) {
            case enums.LOG_LEVEL.DEBUG:
                console.debug('[FeatureFlags]', message);
                break;
            case enums.LOG_LEVEL.WARNING:
                console.warn('[FeatureFlags]', message);
                break;
            case enums.LOG_LEVEL.ERROR:
                console.error('[FeatureFlags]', message);
                break;
            case enums.LOG_LEVEL.INFO:
            default:
                console.info('[FeatureFlags]', message);
                break;
        }
    },
};
const isLoggingEnabled = () => window.localStorage.getItem('enable_feature_flags_logging') === 'true';
export const getLogger = () => {
    return isLoggingEnabled() ? consoleLogger : voidLogger;
};
